import React, { useState, ReactNode } from "react"
import { Container } from "@material-ui/core"
import clsx from "clsx"
import * as styles from "./questionsAnswers.module.scss"
import { variantConfig } from "./variants"
import { PlusIcon } from "./Icons/Plus"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"
import getTextFromNode from "../../../helpers/getTextFromNode"

type FourBlocksProps = {
  orderNum: string
  variant?: "abTest"
  headTitle: string | JSX.Element
}

export const QuestionsAnswers = ({ variant = "abTest", orderNum, headTitle }: FourBlocksProps) => {
  const data = variantConfig[variant]
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const handleCardClick = (index: number, question: ReactNode) => {
    DLClickEventExtended({
      name: getTextFromNode(question).slice(0, 30),
      eventAction: "Вопросы и ответы",
      placement: "faq",
    })
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div id="faq" data-exclude={orderNum}>
      <Container className={clsx(styles.container, variant && styles[variant])}>
        {headTitle && <h2 className={styles.headTitle}>{headTitle}</h2>}

        <div className={styles.cardList}>
          {data.map(({ question, answer }, index) => (
            <button
              type="button"
              key={index}
              className={clsx(styles.card, { [styles.open]: openIndex === index })}
              onClick={() => handleCardClick(index, question)}
            >
              <div className={styles.question}>
                {question}
                <PlusIcon
                  className={clsx(styles.icon, { [styles.rotated]: openIndex === index })}
                />
              </div>
              {openIndex === index && (
                <div className={styles.answerWrapper}>
                  <div className={styles.answer}>{answer}</div>
                </div>
              )}
            </button>
          ))}
        </div>
      </Container>
    </div>
  )
}
